<template>
    <div class="col-md-12 p-0">
		<div >
			<div v-if="rows.length > 0" class="d-flex align-items-center">
				<div class="rows-per-page mb-2 me-2">
					<label for="rowsPerPage">Rows per page:</label>
					<el-select v-model="pageSize" placeholder="" size="medium" @change="onPageSizeChange" id="rowsPerPage"  style="width:70px;">
						<el-option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</el-option>
					</el-select>
				</div>

				<div class="download-excel-container ml-auto">
					<el-select v-model="selectedColumns" multiple collapse-tags
						size="medium" placeholder="Select Column" class="me-2 mb-2" style="width:220px;">
						<el-option v-for="column in defaultColumns" :key="column.field" :label="column.title" :value="column.field">
						</el-option>
					</el-select>

					<el-button v-if="false" class="mb-2" type="success" size="medium" @click="downloadExcel">
						<i class="fa fa-download"></i> &nbsp; Export to Excel
					</el-button>

					<el-dropdown split-button type="success" size="medium" trigger="click" @click="handleClickExport"  @command="handleCommandExport">
						<i class="fa fa-download"></i> &nbsp; Export
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="excel" class="px-4 py-2"><i class="fa fa-file-excel"></i> Export to Excel</el-dropdown-item>
							<el-dropdown-item command="csv" class="px-4 py-2"><i class="fa fa-file-csv"></i> Export to CSV</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

				</div>
			</div>

			<div class="table-responsive">
				<div v-if="rows.length <= 0 && loading == false" class="mt-2 text-center">
					<p>No Data Available. Click the filter to view the data.</p>
				</div>
				<table v-if="rows.length > 0" class="table table-borderless table-hover table-striped no-border table-bs border-top border-bottom table-server-side">
					<thead>
						<tr>
							<th v-for="column in filteredColumns" :key="column.field" @click="sortData(column)" class="sortable position-relative">
								<div class="d-flex justify-content-center align-items-center">
									<span class="flex-grow-1 text-left">{{ column.title }}</span>
									<!-- Sorting Indicators -->
									<span class="d-flex flex-column align-items-center gap-1 end-0 ms-4">
										<span v-if="sortField === column.field">
											<i v-if="sortOrder === 'asc'" class="fa fa-sort-up sort-icon sort-up"></i>
											<i v-if="sortOrder === 'desc'" class="fa fa-sort-down sort-icon sort-down"></i>
										</span>
										<span v-else>
											<i class="fa fa-sort-up sort-icon sort-default"></i>
											<i class="fa fa-sort-down sort-icon sort-default"></i>
										</span>
									</span>
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="row in rows" :key="row.id" @click="onSelectRow(row)">
							<td v-for="column in filteredColumns" :key="column.field" :class="{
								'text-right': column.format === 'number' || column.format === 'decimal' || column.format === 'percent',
								'text-center': column.format === 'date' || column.format === 'datetime'
								}">
								<span v-if="column.format === 'number' || column.format === 'decimal' || column.format === 'percent'">
									{{ formatNum(row[column.field]) }}
								</span>

								<span v-else>
									{{ row[column.field] }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div v-if="rows.length > 0" class="pagination-container pb-1 bg-white" aria-label="Page navigation">
				<div class="pagination-info">
					Showing {{ currentRowStart }} to {{ currentRowEnd }} of {{ totalRows }} rows
				</div>

				<ul v-if="totalPages > 1" class="pagination pagination-controls">

					<li class="page-item" :class="{'disabled cursor-default': page === 1}">
						<button class="page-link" @click="loadPage(1)">First</button>
					</li>

					<li class="page-item" :class="{'disabled cursor-default': page <= 1}">
						<button class="page-link" @click="loadPage(page - 1)">Prev</button>
					</li>

					<li class="page-item cursor-default" v-if="page > 4">
						<span class="page-link cursor-default">...</span>
					</li>

					<li v-for="pageNumber in pageRange" :key="pageNumber" class="page-item" :class="{'active disabled cursor-default': page === pageNumber}">
						<button class="page-link" @click="loadPage(pageNumber)">{{ pageNumber }}</button>
					</li>

					<li class="page-item cursor-default" v-if="page < totalPages - 3">
						<span class="page-link cursor-default">...</span>
					</li>

					<li class="page-item" :class="{'disabled cursor-default': page >= totalPages}">
						<button class="page-link" @click="loadPage(page + 1)">Next</button>
					</li>

					<li class="page-item" :class="{'disabled cursor-default': page === totalPages}">
						<button class="page-link mr-0" @click="loadPage(totalPages)">Last</button>
					</li>
				</ul>
			</div>

			<Loader v-if="loading" />
		</div>

		<div v-if="isDialogVisible" class="dialog-overlay">
			<div class="dialog">
				<h3>Progress</h3>
				<div class="mb-4">
					<p>Halaman: {{ currentPage }} / {{ totalPagesBatch }}  <b>({{ formatNum(progress, 2) }}%)</b></p>
					<div class="progress-bar">
						<div :style="{ width: progress + '%' }"></div>
					</div>
				</div>

				<div v-if="totalParts > 1" class="mb-3">
					<p>Data ini akan dibagi menjadi {{ totalParts }} file dengan total {{ formatNum(totalRows) }} baris data.</p>
				</div>

				<div v-if="isError">
					<p style="color: red;">Terjadi kesalahan saat mengambil data di halaman {{ currentPage }}.</p>
					<el-button class="mb-2" type="success" size="medium" @click="retryDownload">Coba Lagi</el-button>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import axios from 'axios';
import Loader from '@/components/loader/Loader2.vue'
import * as XLSX from 'xlsx'; // Impor library xlsx

export default {
	components: {
		Loader,
	},
    props: {
		columns: {
			type: Array,
			default: () => [],
			//required: true
		},
		apiEndpoint: {
			type: String,
			required: true
		},
		reportname: {
			type: String,
			default: "Excel_Data",
		}
    },
    data() {
      return {
		apiUrl: this.apiEndpoint,
        rows: [],
        page: 1,
        totalPages: 0,
		totalRows: 0,

		pageSize: 10,
		pageSizes: [10, 20, 50, 100],

        sortField: null, // Field yang sedang disortir
        sortOrder: 'asc', // Arah sort ('asc' atau 'desc')

		defaultColumns: this.columns,
		selectedColumns: [],
		loading: false,

		//Download Batch
		limitBatch: 1000,              // Jumlah data per batch
		retries: 3,               // Jumlah percobaan ulang
		isDialogVisible: false,   // Menampilkan dialog
		progress: 0,              // Progress download
		currentPage: 1,           // Halaman saat ini
		totalPagesBatch: 0,
		allData: [],              // Data yang diambil
		isError: false,           // Flag untuk menampilkan error
		retryCount: 0,            // Hitung percobaan ulang
		isFetching: true,
		dataBatchSize: 100000,	// 100 ribu baris per file agar tidak crash
		partCount: 1,
		totalParts: 1,           // Jumlah total file yang akan dibuat

		exportType: 'excel', //excel, csv
      };
    },
	watch: {
		page() {
			this.loadData();
		},
		apiEndpoint(newValue, oldValue) {
			//console.log('old: '+oldValue);
			//console.log('new: '+ newValue);
			this.page = 1;
			this.apiUrl = newValue;
			this.loadData();
		}
    },
    mounted() {
		//this.loadData();
    },
    computed: {
		pageRange() {
			const range = [];
			let start = this.page - 2;
			let end = this.page + 2;

			if (start < 1) {
				start = 1;
				end = Math.min(5, this.totalPages);
			}

			if (end > this.totalPages) {
				end = this.totalPages;
				start = Math.max(this.totalPages - 4, 1);
			}

			for (let i = start; i <= end; i++) {
				range.push(i);
			}

			return range;
		},
		currentRowStart() {
			return (this.page - 1) * this.pageSize + 1;
		},
		currentRowEnd() {
			return Math.min(this.page * this.pageSize, this.totalRows);
		},
		filteredColumns() {
			return this.defaultColumns.filter(column => this.selectedColumns.includes(column.field));
		},
    },
    methods: {
		// Fungsi untuk mengurutkan data berdasarkan kolom
		sortData(column) {
			if (this.sortField === column.field) {
				// Jika kolom yang sama diklik lagi, balikkan arah sorting
				this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
			} else {
				// Jika kolom yang berbeda, urutkan berdasarkan kolom itu dan set order ke 'asc'
				this.sortField = column.field;
				this.sortOrder = 'asc';
			}

			this.loadData();
		},

		loadData() {
			//let url = `${this.apiEndpoint}?page=${this.page}`;
			let url = this.apiUrl; //`http://localhost:8081/api/v1/maintenance/postingshiftsettlement?&date-range-start=2025-1-01&date-range-end=2025-1-15&stationid=&year=2025&month=1&area=&status=&payment=&shift=`;
			url += `&page=${this.page}&limit=${this.pageSize}`;

			if (this.sortField) {
				url += `&sort_by=${this.sortField}&sort_order=${this.sortOrder}`;
			}

			this.loading = true;
			fetch(url)
			.then(response => response.json())
			.then(data => {
				this.rows = data.data;
				this.defaultColumns = data.columns;
				this.totalPages = data.total_pages;
				this.totalRows = data.total_data;
				this.loading = false;

				this.selectAllColumns();
			})
			.catch(error => {
				console.error('Error fetching data:', error);
				this.loading = false;
			});
		},

		// Memuat halaman berdasarkan nomor halaman
		loadPage(page) {
			if (page > 0 && page <= this.totalPages) {
				this.page = page;
				this.loadData();
			}
		},

		// Fungsi yang dipanggil saat memilih jumlah baris per halaman
		onPageSizeChange() {
			this.page = 1; // Reset ke halaman pertama saat jumlah baris per halaman berubah
			this.loadData(); // Ambil data baru sesuai jumlah baris per halaman
		},

		// Fungsi untuk menangani seleksi baris
		onSelectRow(row) {
			this.$emit("on-click-row", row);
		},

		selectAllColumns() {
			this.selectedColumns = this.defaultColumns.map(column => column.field);
		},

		//Download Batch
		async downloadExcel() {
			this.isDialogVisible = true;   // Menampilkan dialog
			//this.allData = [];             // Reset data yang diambil
			this.retryCount = 0;           // Reset percobaan ulang
			this.isError = false;          // Reset flag error
			this.isFetching = true;

			let pageInc = this.currentPage;   // Mulai dari halaman yang ditentukan
			//let totalPages = 0;             // Total halaman yang berhasil diambil
			let totalFetchedPages = 0;

			//set total page download batch
			this.totalPagesBatch = Math.ceil(this.totalRows / this.limitBatch);

			//console.log('totalPagesBatch: ' + this.totalPagesBatch);

			// Menghitung jumlah file yang akan dihasilkan
			this.totalParts = Math.ceil(this.totalPagesBatch * this.limitBatch / this.dataBatchSize);

			while (this.isFetching && pageInc <= this.totalPagesBatch) {
				try {
					let url = this.apiUrl; //`http://localhost:8081/api/v1/maintenance/postingshiftsettlement?&date-range-start=2025-1-01&date-range-end=2025-1-15&stationid=&year=2025&month=1&area=&status=&payment=&shift=`;
					url += `&page=${pageInc}&limit=${this.limitBatch}`;

					// Mengambil data dari API
					const response = await axios.get(url);

					if (response.data.data.length === 0) {
						// Jika tidak ada data lagi, berhenti
						this.isDialogVisible = false;
						this.isFetching = false; // Hentikan loop
						break;
					}

					// Tambahkan data ke dalam array
					this.allData = [...this.allData, ...response.data.data];

					// Update progress
					totalFetchedPages++;
					this.progress = (totalFetchedPages * 100) / this.totalPagesBatch;

					// Update halaman saat ini
					this.currentPage = pageInc;

					// Lanjutkan ke halaman berikutnya
					pageInc++;

					// Simpan data setiap 100.000 data (batch)
					if (this.allData.length >= this.dataBatchSize) {
						if(this.exportType == 'csv')
							this.saveBatchToCSV();
						else
							this.saveBatchToExcel();

						this.allData = []; // Kosongkan data setelah disimpan
						this.partCount++;  // Increment part number
					}

					// Reset retryCount jika berhasil
					this.retryCount = 0;
				} catch (error) {
					console.log(error);
					// Jika terjadi error, coba ulang halaman yang sama
					if (this.retryCount < this.retries) {
						this.isError = true;  // Tampilkan error dan tombol retry
						this.retryCount++;
						return;
					} else {
						// Jika sudah mencapai batas retry, beri pesan error
						//alert('Gagal mengambil data setelah beberapa kali percobaan');
						this.isFetching = false;  // Hentikan loop

						this.$message({
							showClose: true,
							message: 'Failed get data.',
							type: 'error'
						});
						break;
					}
				}
			}

			// Setelah semua data berhasil diambil, buat file Excel
			if (this.allData.length > 0) {
				if(this.exportType == 'csv')
					this.saveBatchToCSV();
				else
					this.saveBatchToExcel();

				this.currentPage = 1;
				this.partCount = 1;
				this.progress = 0;
				this.isFetching = false;
				this.isDialogVisible = false;
				this.allData = [];             // Reset data yang diambil
				//alert('Download selesai!');
				this.$message({
					showClose: true,
					message: 'Berhasil, Download selesai.',
					type: 'success'
				});
			}
		},

		saveBatchToExcel() {
			const ws = XLSX.utils.json_to_sheet(this.allData);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

			// Menentukan nama file:
			// Jika data kurang dari batch size, beri nama 'data.xlsx'
			// Jika lebih dari batch size, beri nama 'data_part_1.xlsx', 'data_part_2.xlsx', dll
			const fileName = this.allData.length >= this.dataBatchSize
				? `${this.reportname} Data_Part_${this.partCount}.xlsx`
				: `${this.reportname}.xlsx`;

			XLSX.writeFile(wb, fileName);
		},

		retryDownload() {
			// Retry hanya halaman yang gagal
			this.isError = false;      // Sembunyikan error
			this.downloadExcel();      // Mulai ulang pengunduhan dari halaman yang gagal
		},

		handleClickExport() {
			this.exportType = 'excel';
			this.downloadExcel();
		},

		handleCommandExport(command) {
			this.exportType = command;
			this.downloadExcel();
			//this.$message('click on item ' + command);
		},


		//CSV
		convertJsonToCsv(jsonData) {
			const keys = Object.keys(jsonData[0]); // Ambil header berdasarkan key dari objek pertama
			const csvRows = [];

			// Tambahkan header
			csvRows.push(keys.join(','));

			// Tambahkan data
			jsonData.forEach(item => {
				const values = keys.map(key => {
				// Escape tanda kutip ganda dan koma di dalam data
				const value = item[key] ? item[key].toString().replace(/"/g, '""') : '';
				return `"${value}"`; // Menambahkan tanda kutip di sekitar setiap nilai
				});
				csvRows.push(values.join(','));
			});

			return csvRows.join('\n'); // Gabungkan header dan data dengan newline
		},

		saveBatchToCSV() {
			if (this.allData.length === 0) {
				//alert('No data to export!');
				this.$message({
					showClose: true,
					message: 'No data to export!',
					type: 'error'
				});
				return;
			}

			const fileName = this.allData.length >= this.dataBatchSize
				? `${this.reportname} Data_Part_${this.partCount}.csv`
				: `${this.reportname}.csv`;

			const csv = this.convertJsonToCsv(this.allData);

			// Membuat file CSV dan memulai download
			const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
			const link = document.createElement('a');
			const url = URL.createObjectURL(blob);
			link.setAttribute('href', url);
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},


    },

};
</script>


<style>
th.sortable {
  cursor: pointer;
}

.table-server-side thead th {
  height: 50px;
  vertical-align: middle !important;

}

/* Default icon colors */
.sort-icon {
  color: #ccc;  /* Warna default untuk ikon */
  transition: color 0.3s ease; /* Transisi warna saat hover */
}

/* Warna saat diurutkan menaik (asc) */
.sort-up {
  color: #28a745; /* Hijau terang untuk urutan menaik */
}

/* Warna saat diurutkan menurun (desc) */
.sort-down {
  color: #dc3545; /* Merah terang untuk urutan menurun */
}

/* Warna untuk ikon ketika belum ada sorting (default state) */
.sort-default {
  color: #ccc; /* #ddd Warna default ketika tidak ada sorting */
}

/* Menambahkan efek hover untuk ikon */
.sort-icon:hover {
  color: #898989;  /* #007bff Biru terang saat hover */
}

/* Mengubah warna icon ketika kolom aktif */
th:hover .sort-icon {
  color: #898989;  /* #007bff Biru terang saat hover pada header */
}

.cursor-default {cursor: default;}

.pagination-container {
  display: flex;
  justify-content: space-between; /* Mengatur jarak antar elemen */
  align-items: center; /* Menyelaraskan elemen secara vertikal */
  margin-top: 15px;
  flex-wrap: wrap;
}

/* Menata informasi jumlah baris yang ditampilkan */
.pagination-info {
  font-size: 14px;
  color: #555;
  margin: 0;
  flex: 1;
  margin-bottom: 10px;
}

/* Menata kontrol pagination */
.pagination-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* Media Queries untuk Responsivitas */
@media (max-width: 768px) {
  .pagination-container {
    flex-direction: column; /* Menumpuk elemen secara vertikal pada layar kecil */
    align-items: flex-start; /* Menyelaraskan ke kiri */
  }

  .pagination-info {
    margin-bottom: 10px;
    font-size: 12px; /* Mengurangi ukuran font pada layar kecil */
  }

  .pagination-controls {
    justify-content: flex-start; /* Menempatkan tombol pagination di kiri pada layar kecil */
  }

  .pagination-controls .page-item {
    margin: 5px 3px; /* Memberikan sedikit margin antar tombol */
    font-size: 12px; /* Ukuran font tombol lebih kecil */
  }

}


@media (max-width: 480px) {
	.pagination-controls .page-item {
		padding: 0px 0px;
		font-size: 10px; /* Ukuran font lebih kecil pada layar sangat kecil */
	}
}

/* Dropdown untuk memilih baris per halaman */
.rows-per-page {
  display: flex;
  align-items: center;
}

.rows-per-page label {
  margin-right: 10px;
  font-size: 14px;
}

.rows-per-page select {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}


/* CSS untuk Dialog dan Progress Bar */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: #f0f0f0;
  background-color: #f0f0f0 !important;
  margin-top: 10px;
  border-radius: 6px;
}

.progress-bar div {
  height: 100%;
  background: green;
  border-radius: 6px;
  transition: width 0.5s ease;
}
</style>
